export const heroStats = [
  { label: '每日更新', value: '50+' },
  { label: '高清片源', value: '10万+' },
  { label: '在线用户', value: '800万+' },
];

export const cardsData = [
  {
    id: 1,
    title: '爆笑综艺合集',
    desc: '精选年度最火搞笑综艺，笑点密集全程高能，解压放松首选。每期邀请当红嘉宾带来意想不到的爆笑互动。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20stage%20with%20warm%20lighting%2C%20entertainment%20studio%20set%20with%20playful%20atmosphere%2C%20vibrant%20orange%20and%20yellow%20decor%2C%20professional%20broadcast%20quality%2C%20cheerful%20and%20energetic%20mood&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '热门推荐',
  },
  {
    id: 2,
    title: '真人秀大冒险',
    desc: '明星嘉宾真实挑战，户外冒险与室内游戏交织，每一期都是全新体验。真实反应带来最纯粹的欢乐。',
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20scene%20with%20warm%20sunset%20lighting%2C%20group%20of%20people%20having%20fun%20in%20nature%2C%20playful%20competitive%20atmosphere%2C%20cinematic%20wide%20shot%2C%20vibrant%20green%20and%20golden%20tones&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '户外挑战',
  },
  {
    id: 3,
    title: '音乐综艺盛典',
    desc: '顶级歌手同台竞技，经典老歌新唱，原创音乐人展示才华。沉浸式音效体验，每首都值得单曲循环。',
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20dramatic%20spotlight%2C%20elegant%20performance%20setting%20with%20warm%20golden%20and%20amber%20lighting%2C%20professional%20concert%20atmosphere%2C%20emotional%20singer%20silhouette%2C%20grand%20theatrical%20mood&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '音乐殿堂',
  },
  {
    id: 4,
    title: '脱口秀开放麦',
    desc: '当红脱口秀演员爆笑开讲，犀利吐槽社会热点，幽默段子金句频出。每期新面孔带来不同风格笑料。',
    image: 'https://readdy.ai/api/search-image?query=Standup%20comedy%20club%20stage%20with%20warm%20intimate%20lighting%2C%20single%20microphone%20spotlight%2C%20cozy%20brick%20wall%20background%2C%20professional%20comedy%20venue%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20tones&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '脱口秀',
  },
  {
    id: 5,
    title: '美食探店日记',
    desc: '跟着镜头走遍全国大街小巷，探寻最地道的美食秘密。深夜放毒预警，每集都让人食欲大开。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20street%20food%20market%20scene%2C%20steaming%20hot%20dishes%20with%20warm%20lighting%2C%20bustling%20night%20market%20atmosphere%2C%20vibrant%20red%20lanterns%20and%20decorations%2C%20appetizing%20food%20photography%20style&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '美食之旅',
  },
  {
    id: 6,
    title: '竞技挑战巅峰',
    desc: '脑力与体力的双重较量，选手们用实力诠释永不言弃。紧张刺激的淘汰赛制，每一轮都扣人心弦。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20game%20show%20arena%20with%20dramatic%20lighting%2C%20competitive%20challenge%20obstacle%20course%2C%20energetic%20participants%20in%20action%2C%20dynamic%20sports%20entertainment%20atmosphere%2C%20bold%20orange%20and%20teal%20accent%20lighting&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '极限挑战',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '年度综艺盛典回顾',
    desc: '2026最受欢迎综艺节目大盘点，回顾那些让人笑中带泪的经典瞬间。',
    duration: '1:28:35',
    views: '1280万',
  },
  {
    id: 2,
    title: '幕后花絮大揭秘',
    desc: '独家探班综艺录制现场，揭密明星嘉宾台前幕后的真实状态与有趣互动。',
    duration: '45:12',
    views: '860万',
  },
  {
    id: 3,
    title: '新人王争霸赛决赛',
    desc: '全国新人喜剧大赛总决赛全程，见证新一代综艺之王的诞生时刻。',
    duration: '2:05:48',
    views: '2100万',
  },
  {
    id: 4,
    title: '经典综艺名场面',
    desc: '近十年经典综艺中的标志性名场面合集，每一帧都是青春回忆杀。',
    duration: '56:20',
    views: '1560万',
  },
];

export const appData = {
  title: '随时随地 轻松看综艺',
  desc: '香蕉影视移动客户端，支持高清缓存下载，地铁通勤、午休时间、睡前放松，打开手机即刻享受海量综艺娱乐内容。智能续播功能记住你的观看进度，断网也能看已缓存节目。',
  features: ['离线缓存', '智能续播', '画质随心', '夜间模式'],
};

export const indexData = [
  { id: 1, title: '喜剧之王争霸', count: '36期', desc: '全国顶尖喜剧人同台竞技，笑料不断' },
  { id: 2, title: '明星大冒险', count: '24期', desc: '当红艺人户外生存挑战，真实又刺激' },
  { id: 3, title: '音乐原创力', count: '18期', desc: '发掘新生代音乐人，原创好歌听不够' },
  { id: 4, title: '美食环游记', count: '52期', desc: '一城一味，探寻中华美食文化精髓' },
  { id: 5, title: '脱口秀大会', count: '30期', desc: '犀利幽默解读生活，金句频出爆笑不断' },
  { id: 6, title: '舞林争霸赛', count: '20期', desc: '顶尖舞者巅峰对决，视觉盛宴震撼呈现' },
  { id: 7, title: '亲子欢乐多', count: '28期', desc: '明星家庭互动真人秀，温馨治愈每一刻' },
];

export const faqData = [
  {
    q: '香蕉影视需要付费观看吗？',
    a: '香蕉影视始终坚持免费高清在线观看，所有综艺娱乐内容无需会员即可畅享。我们通过广告合作维持运营，用户可以免费观看全部节目。',
  },
  {
    q: '为什么香蕉影视播放不卡顿、不缓冲？',
    a: '我们采用先进的CDN加速技术和智能码率自适应方案，根据您的网络状况自动匹配最佳清晰度，确保流畅秒开的观影体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '香蕉影视全面支持手机、平板、电脑和智能电视。您可以通过浏览器直接访问，也可以下载我们的移动客户端获得更佳观看体验。',
  },
  {
    q: '节目更新频率怎么样？',
    a: '我们每天更新50+热门综艺节目，热门节目播出后2小时内即可上线。同时设有更新提醒功能，不错过任何精彩内容。',
  },
  {
    q: '如何反馈观看中遇到的问题？',
    a: '您可以通过页面底部的"联系我们"区域提交反馈，我们的技术团队会在24小时内处理并回复。同时欢迎对内容提出宝贵建议。',
  },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '秒开不卡顿',
    desc: '智能CDN加速，全网最快加载速度，点击即播无需等待缓冲，畅享丝滑观影。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P全高清播放，自适应码率根据网速智能切换，清晰画质始终如一。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '手机、平板、电脑无缝切换，观看记录云端同步，随时随地接着看。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '海量内容',
    desc: '汇聚全网热门综艺娱乐节目，每日更新50+，10万+高清片源任你挑选。',
  },
];

export const aboutData = {
  title: '关于香蕉影视',
  desc1: '香蕉影视是国内领先的综艺娱乐免费高清在线观看平台，致力于为观众提供最新、最热、最全的综艺娱乐内容。自成立以来，我们始终坚持"免费高清、流畅秒开"的服务理念，为数千万用户带来轻松愉悦的观影体验。',
  desc2: '平台汇聚了来自全网的热门搞笑综艺、真人秀、脱口秀、音乐竞技、美食探店等多元化内容，每日更新50+部优质节目，片源总量超过10万部。无论是通勤路上的短暂消遣，还是周末宅家的娱乐时光，香蕉影视都为你准备了最精彩的综艺大餐。',
};

export const rankingData = [
  { rank: 1, title: '喜剧之王争霸 第36期', heat: '9800万', trend: 'up' },
  { rank: 2, title: '明星大冒险 第24期', heat: '8750万', trend: 'up' },
  { rank: 3, title: '脱口秀大会 第30期', heat: '7620万', trend: 'up' },
  { rank: 4, title: '音乐原创力 第18期', heat: '6890万', trend: 'down' },
  { rank: 5, title: '美食环游记 第52期', heat: '6210万', trend: 'up' },
  { rank: 6, title: '舞林争霸赛 第20期', heat: '5430万', trend: 'down' },
];

export const contactData = {
  title: '联系我们',
  desc: '如果您在观看过程中遇到任何问题，或有任何建议与商业合作意向，欢迎随时联系我们。我们的团队将在第一时间为您解答。',
  email: 'feedback@bananatv.com',
  wechat: 'bananatv_official',
  weibo: '@香蕉影视官方',
};

export const updatesData = [
  { date: '2026-07-31', title: '全新综艺《喜剧之王争霸》第三季今日开播，六位喜剧新星同台竞技' },
  { date: '2026-07-30', title: '《明星大冒险》沙漠特辑上线，极限生存挑战引爆全网讨论' },
  { date: '2026-07-29', title: '平台播放技术全面升级，4K超清画质正式开放体验' },
  { date: '2026-07-28', title: '移动客户端新版发布，新增智能续播和夜间模式功能' },
  { date: '2026-07-27', title: '《脱口秀大会》总决赛门票今日开抢，线上线下同步狂欢' },
  { date: '2026-07-26', title: '香蕉影视与五大卫视达成内容战略合作，片源再扩容' },
  { date: '2026-07-25', title: '用户突破800万！感谢每一位支持香蕉影视的观众朋友' },
];

export const commentsData = [
  {
    name: '综艺迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20friendly%20smile%2C%20casual%20style%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2天前',
    content: '用过最流畅的综艺网站！真的做到了秒开不缓冲，地铁上看一点都不卡。内容更新也超快，好评！',
  },
  {
    name: '快乐追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20modern%20casual%20look%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '3天前',
    content: '每天午休必看香蕉影视，脱口秀和美食节目是我最爱，笑点密集又下饭，推荐给所有同事了！',
  },
  {
    name: '深夜观影者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%20thirties%20portrait%2C%20gentle%20expression%2C%20stylish%20glasses%2C%20warm%20indoor%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '5天前',
    content: '高清画质真的很赞，在大屏电视上看效果一流。综艺种类也全，想看的都能找到，免费真的良心。',
  },
  {
    name: '综艺达人小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20energetic%20smile%2C%20trendy%20casual%20outfit%2C%20bright%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '6天前',
    content: '从朋友推荐来的，一用就停不下来！每天更新50+部，追都追不完。离线缓存功能通勤神器！',
  },
  {
    name: '老综艺粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20kind%20smile%2C%20relaxed%20casual%20style%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '1周前',
    content: '看综艺十几年了，香蕉影视是我用过最舒服的平台。界面清爽没广告打扰，内容质量也高。',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '喜剧之王争霸·第三季',
    desc: '六大喜剧流派巅峰对决，谁能笑到最后？',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20stage%20with%20bright%20colorful%20spotlights%2C%20energetic%20performers%20in%20action%2C%20golden%20confetti%20falling%2C%20theatrical%20entertainment%20atmosphere%2C%20vibrant%20warm%20orange%20and%20red%20lighting&width=600&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '明星大冒险·沙漠篇',
    desc: '极限环境下的真实生存挑战，不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Vast%20desert%20landscape%20with%20golden%20sand%20dunes%2C%20adventure%20reality%20show%20setting%2C%20dramatic%20warm%20sunset%20sky%2C%20cinematic%20wide%20shot%2C%20epic%20scale%20with%20warm%20amber%20and%20terracotta%20tones&width=600&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '音乐原创力·新声季',
    desc: '原创音乐人的舞台，发现你的下一首单曲循环。',
    image: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20warm%20ambient%20lighting%2C%20instruments%20and%20microphone%20setup%2C%20creative%20artistic%20atmosphere%2C%20professional%20music%20production%20environment%2C%20deep%20amber%20and%20golden%20tones&width=600&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '脱口秀大会·总决赛',
    desc: '年度最强嘴炮大战，金句与笑声齐飞。',
    image: 'https://readdy.ai/api/search-image?query=Standup%20comedy%20theater%20with%20intimate%20stage%20lighting%2C%20single%20microphone%20under%20spotlight%2C%20packed%20audience%20silhouettes%2C%20warm%20dramatic%20atmosphere%2C%20deep%20red%20and%20golden%20accents&width=600&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '美食环游记·川渝篇',
    desc: '麻辣鲜香的巴蜀之旅，隔着屏幕都能闻到香味。',
    image: 'https://readdy.ai/api/search-image?query=Sichuan%20hotpot%20and%20street%20food%20scene%2C%20steaming%20colorful%20dishes%2C%20traditional%20Chinese%20restaurant%20interior%20with%20red%20lanterns%2C%20warm%20inviting%20atmosphere%2C%20rich%20red%20and%20golden%20tones&width=600&height=400&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '舞林争霸赛·巅峰战',
    desc: '顶级舞者燃爆全场，每一帧都是视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Dance%20competition%20stage%20with%20dramatic%20moving%20spotlights%2C%20graceful%20dancer%20in%20motion%2C%20dynamic%20performance%20energy%2C%20professional%20theater%20setting%2C%20vibrant%20warm%20orange%20and%20crimson%20lighting&width=600&height=400&seq=carousel-06&orientation=landscape',
  },
];

export const topicsData = [
  { name: '喜剧之王争霸', heat: '9800万热议' },
  { name: '明星大冒险', heat: '8750万热议' },
  { name: '脱口秀大会', heat: '7620万热议' },
  { name: '综艺推荐', heat: '6520万热议' },
  { name: '今日更新', heat: '5890万热议' },
  { name: '搞笑名场面', heat: '5210万热议' },
  { name: '音乐综艺', heat: '4680万热议' },
  { name: '美食探店', heat: '3950万热议' },
  { name: '真人秀', heat: '3420万热议' },
  { name: '高清观影', heat: '2890万热议' },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '专题合集', href: '#index' },
  { label: '热门话题', href: '#topics' },
  { label: '移动客户端', href: '#app' },
  { label: '最新动态', href: '#updates' },
  { label: '联系我们', href: '#contact' },
];